import {
  PlanningEvent,
  PlanningStatus,
  PlanningSeverity,
} from "../models/planning-event.model";

export function commandesClientToPlanningEvents(
  commandes: any[],
): PlanningEvent[] {
  if (!commandes?.length) return [];
  const today = new Date();

  return commandes
    .filter((c) => c.dateLivraisonPrevue != null)
    .map((c) => {
      const { status, severity } = deriveCcStatus(
        c.etat,
        c.dateLivraisonPrevue,
        today,
      );
      const client = c.tiers?.denomination ?? "";
      const numero = c.numeroCommandeClient ?? c.numero ?? "?";

      return {
        id: `commande-client:${c.id}`,
        source: "commande-client" as const,
        kind: "delivery",
        reference: {
          label: client || numero,
          route: [`/commandeclient/details/id/${c.id}/commande-client`],
        },
        datePrevu: c.dateLivraisonPrevue
          ? new Date(c.dateLivraisonPrevue).toISOString()
          : null,
        dateReel: c.dateTermine
          ? new Date(c.dateTermine).toISOString()
          : c.dateExpedition
            ? new Date(c.dateExpedition).toISOString()
            : null,
        status,
        severity,
        quantite: undefined,
        payload: {
          client,
          numero,
          etat: c.etat,
          etatLabel: ccEtatToLabel(c.etat),
        },
      } satisfies PlanningEvent;
    });
}

function deriveCcStatus(
  etat: string,
  datePrevue: Date | string | null,
  today: Date,
): { status: PlanningStatus; severity: PlanningSeverity } {
  switch (etat) {
    case "ANNULEE":
      return { status: "cancelled", severity: 0 };
    case "TERMINE":
    case "FACTURE":
      return { status: "completed", severity: 0 };
    case "EXPEDIE":
      return { status: "completed", severity: 0 };
    case "EXPEDIE_PARTIELLEMENT":
      return { status: "partial", severity: 1 };
    case "PRETE":
    case "EN_COURS_DE_PREPARATION":
      return { status: "in_progress", severity: 0 };
    case "EN_COURS_DE_TRAITEMENT":
    case "EN_ATTENTE_CONFIRMATION":
    case "EN_REDACTION": {
      if (datePrevue) {
        const d = new Date(datePrevue);
        d.setHours(23, 59, 59, 999);
        if (d < today) return { status: "late", severity: 2 };
      }
      return { status: "pending", severity: 0 };
    }
    default:
      return { status: "pending", severity: 0 };
  }
}

function ccEtatToLabel(etat: string): string {
  const labels: Record<string, string> = {
    EN_REDACTION: "Brouillon",
    EN_ATTENTE_CONFIRMATION: "À confirmer",
    EN_COURS_DE_TRAITEMENT: "En traitement",
    EN_COURS_DE_PREPARATION: "En préparation",
    PRETE: "Prête",
    EXPEDIE: "Expédiée",
    EXPEDIE_PARTIELLEMENT: "Expéd. partielle",
    FACTURE: "Facturée",
    ANNULEE: "Annulée",
    TERMINE: "Terminée",
  };
  return labels[etat] ?? etat;
}
